import { render } from "./AgentsView.vue?vue&type=template&id=1b218da3&scoped=true"
import script from "./AgentsView.vue?vue&type=script&lang=js"
export * from "./AgentsView.vue?vue&type=script&lang=js"

import "./AgentsView.vue?vue&type=style&index=0&id=1b218da3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b218da3"]])

export default __exports__